module.exports = __webpack_public_path__ + "static/transparency_report2019@2x-1b93b217f485e3ee4876c62654a009d9.jpg";